export default class Entity {
  entities: Array<Entity> = [];

  constructor(public id: number, public type: number, public title: string, public subtitle?: string) {

  }
}
